/**
 * Copyright ©2022 Drivepoint
 */

import React, {ReactNode, useEffect, useState} from "react";
import PrimaryIcon from "../styled/PrimaryIcon";
import {ChevronLeft} from "@mui/icons-material";
import {ListItemText} from "@mui/material";
import BrandedMenu from "../styled/BrandedMenu";
import ThemedMenuItem from "../styled/ThemedMenuItem";

interface SubMenuProps {
  label: string;
  open: boolean;
  onClose: () => void;
  children: ReactNode;
}

export default function SubMenu(props: SubMenuProps): any {

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [inItem, setInItem] = useState<boolean>(false);
  const [inMenu, setInMenu] = useState<boolean>(false);
  const [timer, setTimer] = useState<any>();
  const [itemsEl, setItemsEl] = useState<null | HTMLElement>();

  useEffect(() => {
    clearTimeout(timer);
    if (!inItem && !inMenu) {
      setTimer(setTimeout(() => {
        if (!inItem && !inMenu) { hide(); }
      }, 250));
    }
  }, [inItem, inMenu]);

  useEffect(() => {
    const visible = !!anchorEl && props.open && !!itemsEl;
    if (visible) {
      itemsEl?.querySelector(".selected")?.scrollIntoView({behavior: "smooth", block: "center"});
    }
  }, [anchorEl, props.open, itemsEl]);

  function hide() {
    clearTimeout(timer);
    setAnchorEl(null);
    setInMenu(false);
    setInItem(false);
  }

  function close() {
    hide();
    props.onClose();
  }

  function onMenuItemEnter(event: any): void {
    setAnchorEl(event.target);
    setInItem(true);
  }

  return <div>
    <ThemedMenuItem onMouseEnter={onMenuItemEnter} onMouseLeave={() => setInItem(false)}>
      <PrimaryIcon><ChevronLeft /></PrimaryIcon>
      <ListItemText>{props.label}</ListItemText>
    </ThemedMenuItem>
    <BrandedMenu
      style={{pointerEvents: "none"}}
      open={!!anchorEl && props.open}
      onClose={close}
      anchorEl={anchorEl}
      anchorOrigin={{vertical: "top", horizontal: "left"}}
      transformOrigin={{vertical: "top", horizontal: "right"}}
      MenuListProps={{
        onMouseEnter: () => setInMenu(true),
        onMouseLeave: () => setInMenu(false)
      }}
    >
      <div ref={(ref) => setItemsEl(ref)} style={{pointerEvents: "auto", maxHeight: "20rem", overflowY: "auto"}}>
        {props.children}
      </div>
    </BrandedMenu>
  </div>;
}
